import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'serviceIcon',
    standalone: false,
    pure: true
})
export class ServiceIconPipe implements PipeTransform {
  transform(serviceKey: string): string {
    if (!serviceKey) {return 'schedule';}
    if (serviceKey.includes('two_pros') || serviceKey.includes('turnover')) {
      return 'groups';
    }
    return 'schedule';
  }
}
